<template>
    <div class="container text-center mt-5">
      <h1 class="display-1 text-danger">404</h1>
      <p class="lead">Página no encontrada</p>
      <router-link to="/" class="btn btn-primary">Volver al inicio</router-link>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ViewNotFound'
  };
  </script>
  
  <style scoped>
  .container {
    padding-top: 50px;
  }
  </style>
  